import { DailyRide } from '../../rides/features/DailyRides/useDailyRides';
import { getWithParamsRequest, postRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export interface ShareAccessPayload {
  emails: string[];
  defaultAccountLocationId: number;
}

export async function shareAccess(payload: ShareAccessPayload): Promise<ApiResponse<{ message: string }>> {
  return postRequest('daily_trips/share_access', payload);
}

export async function getDailyRides(
  params: {
    tab: string;
    accountLocationId: string | null;
    date: string;
    q: string | null;
    state?: string;
  },
  signal?: AbortSignal
): Promise<ApiResponse<DailyRide[]>> {
  return getWithParamsRequest('daily_trips', params, signal);
}

export async function getDailyRidesToPrint(
  params: {
    tab: string;
    accountLocationId: string;
    date: string;
  },
  signal?: AbortSignal
): Promise<ApiResponse<DailyRide[]>> {
  return getWithParamsRequest('daily_trips/print', params, signal);
}
